<div
  class="kr-wallet-edit__header"
  data-testid="wallet_details_edit_wallet_header">
  <h4
    class="kr-wallet-edit__header-text"
    data-testid="wallet_details_edit_wallet_header_text">
    {{ wallet.name }}
  </h4>

  <button
    class="kr-wallet-edit__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    data-testid="wallet_details_edit_wallet_close_btn"
    [onlyIcon]="true"
    (click)="close()">
    <fu-icon
      iconName="close-square"
      data-testid="wallet_details_edit_wallet_close_icon"></fu-icon>
  </button>
</div>

<div class="kr-wallet-edit__body" data-testid="wallet_details_edit_wallet_body">
  <kr-wallet-card
    [wallet]="wallet"
    [(walletName)]="walletName"
    data-testid="wallet_details_edit_wallet_card"
    large
    editable />

  <fu-checkbox
    [(value)]="forDelete"
    [label]="'walletDetails.btn.iWantToDeleteThisWallet' | translate"
    data-testid="wallet_details_edit_wallet_delete_checkbox" />

  <div class="kr-actions" data-testid="wallet_details_edit_wallet_actions">
    <button
      type="button"
      fuButton
      size="m"
      uiType="primary"
      data-testid="wallet_details_edit_wallet_cancel_btn"
      (click)="close()">
      {{ 'walletEdit.btn.cancel' | translate }}
    </button>

    <button
      type="button"
      fuButton
      size="m"
      uiType="secondary"
      data-testid="wallet_details_edit_wallet_apply_btn"
      (click)="apply()"
      [disabled]="disabledApply()">
      {{ 'walletEdit.btn.apply' | translate }}
    </button>
  </div>
</div>
